<template>
  <v-container>
    <v-sheet class="pa-8">
      <div class="d-flex align-center mb-5">
        <div class="title">{{$t('album.sheet.review.title')}}</div>
      </div>
      <v-divider></v-divider>
      <v-sheet>
        <v-btn v-if="false" @click="addReview">add reviews</v-btn>

<v-timeline dense>
      <v-timeline-item
        v-for=" (review, index) in reviews"
        :key="index"
        :color="getReviewColor(review.state)"
        fill-dot
      >
        <v-card
          class="mx-auto ma-12"
          max-width="600"
          :color="getReviewColor(review.state)"
        >
          <v-img
            v-for=" (imgUuid, index) in review.data.attachments"
            :key="'attachment_' + index"
            width="600"
            height="600"
            :src="getImage(imgUuid)"
          ></v-img>
          <v-card-title class="d-flex">
            <div class="mr-2">{{$t('album.sheet_state.review_state') + ": "}}</div>
            <div>{{ getReviewState(review.state)}}</div>
          </v-card-title>

          <v-card-text class="d-flex">
            <!-- <div class="mr-2">{{$t('album.sheet.review.submit') + ": "}}</div>
            <div>{{ review.data.content}}</div> -->
            <div class="mr-2">{{$t('album.create_at')}}:</div>
            <div>{{ review.humanTime }}</div>
          </v-card-text>
          <v-card-text class="d-flex">
            <div class="mr-2">{{$t('album.sheet.review.review_reply') + ": "}}</div>

            <div>{{ review.data.reply}}</div>
          </v-card-text>
        </v-card>
      </v-timeline-item>
      </v-timeline>
      </v-sheet>
    </v-sheet>
  </v-container>
</template>

<script>
export default {
  name: "AlbumReviewDetail",
  components: {},
  data: function() {
    return {
      currentAlbum: this.$store.getters.currentAlbum,
      reviews: null
    };
  },
  created() {
    if (!this.currentAlbum) return;
    console.log('getReviews');
    this.commonUtils.getAlbumReviews(this, this.currentAlbum.uuid).then(
      function(reviews) {
        console.log('the review', reviews);
        this.reviews = reviews;
      }.bind(this)
    );
  },
  computed: {},
  methods: {
    addReview: function() {
      this.commonUtils
        .addReviews(this, "text 111", this.currentAlbum.uuid)
        .then(function(reviews) {
          console.log(reviews);
        });
    },
    getReviewState: function(state) {
      if (state == "created" || state == "pass" || state == "rejected") {
        return this.$t(`album.sheet.review.state.${state}`);
      } else {
        return "";
      }
    },
    getReviewColor: function(state) {
        console.log('state', state)
        if (state == 'created') {
            return 'primaryLight';
        } else if (state == 'rejected') {
            return 'errorlight';
        } else if (state == 'pass') {
            return 'success';
        } else {
            return "white";
        }
    },
    getImage: function(uuid) {
      return this.commonUtils.getReviewImageUrl(uuid);
    },
    getCreateTime: function(timeString) {
        return this.commonUtils.convertTimeFormat(timeString, true);
    }
  }
};
</script>

<style scoped>
.title {
  /* font-family: SHBold; */
  font-weight: bold;
  font-size: 20px;
}
</style>
